// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__vGIg_","title":"AfterBackImages_title__3Z1aX","images":"AfterBackImages_images__1MARX"};